const env = window.getparam('env') || 'prod';
const lang = window.getparam('lang') || 'en';
const platform = window.getparam('platform') ? true : false;
const appUrl = `https://content.webapi-services.net/web_assets/scripts/daily-videos/static/js/main.js?env=${env}`;

const script = document.createElement('script');
script.src = appUrl;
script.async = true;
script.defer = true;
script.onload = function(){
    const app = document.getElementById('video-app-container');
    window.DailyAnalysisVideos.startVideoApp(app, platform, lang);
    app.classList.remove('loading');
}
document.body.appendChild(script);